import { render, staticRenderFns } from "./WorkspaceDropdown.vue?vue&type=template&id=41bd25b2"
import script from "./WorkspaceDropdown.vue?vue&type=script&lang=ts&setup=true"
export * from "./WorkspaceDropdown.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./WorkspaceDropdown.vue?vue&type=style&index=0&id=41bd25b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports